import { CloseOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import styled from "styled-components"

import Flex from "#blocks/Flex"

const SBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: #1677ff;
  background: #e6f4ff;
  border: 1px solid #91caff;
  border-radius: 9px;
`

interface PriorityBadgeProps {
  /** 1-based priority position. When undefined, the badge is hidden. */
  priorityIndex?: number
  /** Renders a small remove-X next to the badge. */
  onRemoveFromPriority?: () => void
}

const PriorityBadge = ({
  priorityIndex,
  onRemoveFromPriority,
}: PriorityBadgeProps) => {
  if (priorityIndex === undefined && !onRemoveFromPriority) return null

  return (
    <Flex
      gap={2}
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        alignItems: "center",
      }}
    >
      {priorityIndex !== undefined && (
        <Tooltip title={`Priority #${priorityIndex}`}>
          <SBadge aria-label={`Priority #${priorityIndex}`}>
            {priorityIndex}
          </SBadge>
        </Tooltip>
      )}
      {onRemoveFromPriority && (
        <Button
          icon={<CloseOutlined />}
          onClick={(event) => {
            event.stopPropagation()
            onRemoveFromPriority()
          }}
          size="small"
          type="text"
          aria-label="Remove from priority lane"
        />
      )}
    </Flex>
  )
}

export default PriorityBadge
